import { useMutation, useQuery } from "@apollo/client";
import { LocationGenerics } from "router/location";
import { ConfirmPremiumServiceInterestForm } from "components/forms";
import { Modal } from "components/layouts";
import { useFormik } from "formik";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useSearch } from "react-location";
import { ASSIGN_SERVICE_ORDER, GET_SERVICE_ORDER } from "./apollo";

export default function AssignRATServiceOrderContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_SERVICE_ORDER, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
    skip: !searchParams.id,
  });
  const [assignServiceOrder] = useMutation(ASSIGN_SERVICE_ORDER);

  const form = useFormik({
    initialValues: {
      assigneeInfo: {
        assignee: null as any,
      },
      extraInfo: {
        estimatedResolutionDate: "",
        digitalAddress: "",
        priority: "Low",
        notes: "",
      },
    },
    onSubmit: async (values) => {
      await assignServiceOrder({
        variables: {
          id: searchParams.id,
          assignee: values.assigneeInfo?.assignee?._id,
          ...values.extraInfo,
        },
      }).then(({ data: result }) => {
        if (result?.assignServiceOrder?._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "RAT Service Order Assigned Successfully",
            }),
          );
          refetch?.();
          form.resetForm();
          setOpen(false);
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not assign RAT Service Order",
            }),
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  useEffect(() => {
    const order = data?.serviceOrder;
    if (!order?._id) return;
    form.setFieldValue("extraInfo", {
      estimatedResolutionDate: order.estimatedResolutionDate || "",
      digitalAddress: order.digitalAddress || "",
      priority: order.priority || "Low",
      notes: order.notes || "",
    });
    if (order.assignee?._id) {
      form.setFieldValue("assigneeInfo.assignee", order.assignee);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.serviceOrder?._id]);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      hideActions={true}
      title="Assign Readiness Assessment Test"
      size="4xl"
      description="Provide the details to assign this readiness assessment test order"
    >
      {data?.serviceOrder?._id && (
        <ConfirmPremiumServiceInterestForm form={form} />
      )}
    </Modal>
  );
}
